import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { prefersReducedMotion, qsa } from '@/lib/dom'

/**
 * 見出しのスクロール連動リビール。
 *  - `.js-trigger-title` … セクション冒頭の大見出し
 *  - `.c-section-title`  … 各セクションの共通見出し
 */
export function initTitleReveal(): void {
  const titles = [...qsa<HTMLElement>('.js-trigger-title'), ...qsa<HTMLElement>('.c-section-title')]
  if (titles.length === 0) return

  if (prefersReducedMotion()) {
    gsap.set(titles, { opacity: 1, y: 0 })
    return
  }

  titles.forEach((title) => {
    gsap.fromTo(
      title,
      { opacity: 0, y: 40 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: title,
          start: 'top 85%',
          once: true,
        },
      },
    )
  })

  ScrollTrigger.refresh()
}
